import request from "@/utils/request";

export function getCarType(){
    return request({
        url:`/basic/driverapp/api/carAttribute/findAllCarAttribute`,
		method:'GET',
    })
}
 
export function getCarTypeCost(id){
    return request({
        url:`/basic/driverapp/api/carAttribute/multiplefind/${id}`,
        method:'GET'
    })
}